import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@auth0/auth0-angular';

import { AuthCallbackComponent } from '@core/auth/auth-callback/auth-callback.component';
import { SigninComponent } from '@core/auth/signin/signin.component';
import { CGUGuard } from '@core/guards/cgu.guard';
import { CustomerGuard } from '@core/guards/customer.guard';
import { FormalistGuard } from '@core/guards/formalist.guard';
import { NotaryGuard } from '@core/guards/notary.guard';
import { UserGuard } from '@core/guards/user.guard';
import { AppRoute } from '@core/navigation/app-route.enum';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'formalities',
    pathMatch: 'full'
  },
  { path: AppRoute.signin, component: SigninComponent },

  { path: AppRoute.authCallback, component: AuthCallbackComponent },
  {
    path: 'formalities',
    canActivate: [AuthGuard, UserGuard, CGUGuard, CustomerGuard],
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule)
  },
  {
    path: 'formalist',
    canActivate: [AuthGuard, UserGuard, FormalistGuard],
    loadChildren: () => import('./formalist/formalist.module').then(m => m.FormalistModule)
  },
  {
    path: 'notary',
    canActivate: [AuthGuard, UserGuard, NotaryGuard],
    loadChildren: () => import('./notary/notary.module').then(m => m.NotaryModule)
  },
  {
    path: 'cgu',
    canActivate: [AuthGuard, UserGuard],
    loadChildren: () => import('./cgu/cgu.module').then(m => m.CGUModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', canceledNavigationResolution: 'computed' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
